import { render, staticRenderFns } from "./ForgotUsernameUserDetailsComponent.vue?vue&type=template&id=3d8623be&scoped=true"
import script from "./ForgotUsernameUserDetailsComponent.vue?vue&type=script&lang=js"
export * from "./ForgotUsernameUserDetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./ForgotUsernameUserDetailsComponent.vue?vue&type=style&index=0&id=3d8623be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8623be",
  null
  
)

export default component.exports